/**
 * Library Store — folder navigation, template browsing, view mode
 */
import { createStore } from 'zustand/vanilla';
import type { SportFolder, TemplateDefinition } from '@graphicsim/shared-types';
import { eventBus } from '../engine/eventBus';

export interface LibraryState {
  folders: SportFolder[];
  currentFolderId: string | null; // null = root level showing folders
  viewMode: 'grid' | 'list';
  templates: TemplateDefinition[]; // templates in current folder
  // Actions
  setFolders: (folders: SportFolder[]) => void;
  enterFolder: (folderId: string) => void;
  goBack: () => void;
  setViewMode: (mode: 'grid' | 'list') => void;
  setTemplatesForFolder: (templates: TemplateDefinition[]) => void;
}

export const libraryStore = createStore<LibraryState>((set, get) => ({
  folders: [],
  currentFolderId: null,
  viewMode: 'grid',
  templates: [],

  setFolders: (folders) => set({ folders }),

  enterFolder: (folderId) => {
    set({ currentFolderId: folderId });
    eventBus.emit('library:folderSelected', { folderId });
  },

  goBack: () => {
    set({ currentFolderId: null, templates: [] });
    eventBus.emit('library:folderBack', {});
  },

  setViewMode: (mode) => {
    set({ viewMode: mode });
    eventBus.emit('library:viewChanged', { view: mode });
  },

  setTemplatesForFolder: (templates) => set({ templates }),
}));
